import { Button, Tooltip } from '@customerio/pluma-components/react';
import { useOpenSendEventModal } from '@/features/send-event';
import { useCanSendTestEvent } from '@/services/permissions';

/**
 * Send one event without leaving the data index, so a workspace that has
 * just set an event up can see it arrive.
 *
 * The events browser knows nothing about the send yet; an event's own page
 * knows which event it is. Everything else the modal asks for.
 */

type SendEventButtonProps = {
  workspaceId: number;
  /** The event to send, when the surface already knows which one. */
  eventName?: string;
  /** Where the modal was opened from, as analytics names it. */
  source: string;
};

export function SendEventButton({ workspaceId, eventName, source }: SendEventButtonProps) {
  const canSend = useCanSendTestEvent();
  const openSendEvent = useOpenSendEventModal();

  return (
    <Tooltip isDisabled={canSend} content="Contact an Admin to access this feature." isCustom={true}>
      {(context) => (
        <Button
          ref={context.reference.setReference}
          {...context.reference.getReferenceProps()}
          variant="primary"
          isDisabled={!canSend}
          onClick={() => openSendEvent({ workspaceId, eventName, source })}
        >
          Send event
        </Button>
      )}
    </Tooltip>
  );
}
